<template>
  <!-- Need to place something to DOM to be rendered correctly -->
  <div/>
</template>

<script>
  import mqtt from 'mqtt'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        client: null,
        roleChangeChannel: null
      }
    },
    computed: {
      ...mapGetters([
        'authenticatedUser',
        'cognitoSubject'
      ])
    },
    watch: {
      authenticatedUser: {
        handler() {
          if (this.authenticatedUser === null || !this.client || !this.client.connected) {
            return
          }
          if (this.authenticatedUser === false) {
            this.client.unsubscribe(this.roleChangeChannel)
          }
          this.subscribeTenantRoleChanges()
        }
      }
    },
    created() {
      this.client = mqtt.connect('', {
        reconnectPeriod: 60000, // set reconnection period to 1 minute
        transformWsUrl: () => {
          return this.$PfxBackendApi.getNotificationUrl() // note: synchronous call -> will freeze the site for a moment
        }
      })

      this.client.on('connect', () => {
        console.log('Subscribing to message channel')
        this.client.subscribe('auction')
        this.client.subscribe('auction_role')
        this.subscribeTenantRoleChanges()
      })

      this.client.on('close', () => {
        this.client.end(true, () => {
          console.log('connection closed')
        }) // don't reconnect
        this.client = undefined
      })

      this.client.on('message', (topic, message) => {
        if ( topic === this.roleChangeChannel) {
          this.$store.dispatch('reloadTenantRole')
        } else {
          this.$events.emit(topic, JSON.parse(message.toString()))
        }
      })
    },
    destroyed() {
      if (typeof this.client !== 'undefined') {
        console.log('Gracefully closing the connection...')
        this.client.end(true)
      }
    },
    methods: {
      subscribeTenantRoleChanges() {
        if (this.authenticatedUser === true) {
          this.roleChangeChannel = this.cognitoSubject
          this.client.subscribe(this.cognitoSubject)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/elements/MqttDispatcher.vue